export enum OrganizationAddressTypes {
  billing = 'billing',
  shipping = 'shipping'
}
